<template>
  <div>
    <vue-ins-progress-bar />
    <component :is="layout">
      <RouterView />
    </component>
    <div
      id="scroll-to-top"
      class="scrolltop text-center"
    >
      <i
        class="fas fa-chevron-up"
        style="font-size: 20px;"
      />
    </div>
    <div id="swal-output" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import MainLayout from '@/components/layouts/MainLayout.vue'
import AuthorizationLayout from '@/components/layouts/AuthorizationLayout.vue'
import BlankLayout from '@/components/layouts/BlankLayout.vue'

import MISC from '@/mixins/misc'

export default {
  name: 'App',
  components: {
    'layout-main': MainLayout,
    'layout-auth': AuthorizationLayout,
    'layout-blank': BlankLayout
  },
  mixins: [
    MISC
  ],
  metaInfo () {
    const appName = process.env?.VUE_APP_TITLE || ''
    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },
  computed: Object.assign(
    {
      layout () {
        switch (this.$route.meta.layout) {
          case 'auth': {
            return 'layout-auth'
          }
          case 'sso': {
            return 'layout-blank'
          }
          default: {
            if (this.user?.id) {
              return 'layout-main'
            }

            return 'layout-auth'
          }
        }
      }
    },
    mapGetters({
      offline: 'offline-storage/offlineState',
      user: 'auth/user'
    })
  ),

  mounted () {
    this.$insProgress.finish()
  },

  methods: {
    ...mapActions({
      offlineAction: 'offline-storage/offlineAction'
    })
  }
}
</script>
<style lang="scss">
  @import "./assets/scss/style.scss";
</style>
<style>
  @import "./assets/css/custom.css";
</style>
